import { produce } from 'immer';
import processReducer from './stateHelper';

const withDraft = (handler) => (state, action = null) => produce(state, (draft) => {
  handler(draft, action);
  return draft;
});

export const chooseReducer = (state, action, reducers) => {
  const reducer = reducers[action.type];
  return reducer ? processReducer(state, action, reducer) : state;
};

export default withDraft;
